<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="quickFilter" class="label">Filtro rapido</label>
          <input
            type="text"
            class="form-control"
            id="quickFilter"
            v-model="quickFilter"
          />
        </div>
      </div>
    </div>
    <div class="row" style="height: 100%">
      <div class="col" style="position: relative; height: 100%">
        <ag-grid-vue
          style="width: 100%; height: 60vh"
          class="ag-theme-alpine"
          @grid-ready="onGridReady"
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :modules="modules"
          :rowData="rowData"
          :getContextMenuItems="getContextMenuItems"
        >
        </ag-grid-vue>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { AllModules } from "ag-grid-enterprise";

export default {
  name: "EstadoDeCuentasGrid",
  props: ["rowData", "columnDefs"],
  components: { AgGridVue },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    autoSizeAll(skipHeader) {
      let allColumnIds = [];
      this.gridColumnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    },
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
  },
  data: () => ({
    quickFilter: "",

    modules: AllModules,

    gridOptions: {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    },
    gridApi: null,

    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    },
  }),
  watch: {
    quickFilter(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  beforeMount() {
    this.gridOptions = {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    };
  },
};
</script>
